/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_No_Client_BodyInputs */



/**
* | output |
* | --- |
* | "These pages show one client's portal. Preview it as one of your clients, and you will see exactly what they see." |
*
* @param {Portal_No_Client_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_no_client_body = /** @type {((inputs?: Portal_No_Client_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_No_Client_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("These pages show one client's portal. Preview it as one of your clients, and you will see exactly what they see.")
});